import { useContext } from "react";
import ActiveItemDivider from "./ActiveItemDivider";
import { CraftPredictionContext } from "pages/CraftPrediction";
import useActiveItem from "hooks/useActiveItem";

const ActiveItemIPredictionCraftSelect = ({ item }) => {
  const {activeItem} = useActiveItem();
  const { selectItemHandler, playSound } = useContext(CraftPredictionContext);

  const selectHandler = (item) => {
    selectItemHandler(item);
    playSound("craftSelectItem");
  };

  if (item.type.toLowerCase() === "event" && item.is_valid_event === false) {
    return <ActiveItemDivider />
  }

  return (
    <>
      {activeItem.owned_by_self && <button
        className="card-details__combine-action card-details__combine-action--select"
        onClick={() => selectHandler(item)}
      >
        Select
      </button>}
      <ActiveItemDivider />
    </>
  );
};

export default ActiveItemIPredictionCraftSelect;
